import { Navigate, Outlet, useLocation } from 'react-router-dom';
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import RouterPaths from '../../constants/RouterPaths';

function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = useSelector((state) => state.auth.get('isAuthenticated'));
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={RouterPaths.HOMEPAGE} state={{ from: location }} replace />;
  }

  return Component ? <Component {...rest} /> : <Outlet />;
}

ProtectedRoute.propTypes = {
  // eslint-disable-next-line react/require-default-props
  component: PropTypes.elementType,
};

export default ProtectedRoute;
